<div class="app" [class.collapsed]="collapsed()">

  <!-- ── Sidebar ──────────────────────────────────────────── -->
  <aside class="sidebar" [class.open]="sidebarOpen()">

    <div class="brand">
            <div class="brand-logo"><img [src]="themeService.isDark() ? '/logo.png' : '/logo_black_outline.png'" alt="Malahy" /></div>
      <div class="brand-name">Malah<span>y</span></div>
    </div>

    <div class="nav-scroll">
      @for (group of nav(); track group.label) {
        <div class="nav-group">
          @if (group.label) { <div class="nav-label">{{ group.label | translate }}</div> }
          @for (item of group.items; track item.key) {
            @if (item.children) {
              <button class="nav-item" type="button"
                      [class.parent-open]="isItemOpen(item.key)"
                      [class.has-active-child]="isChildActive(item)"
                      (click)="toggleItem(item.key)"
                      (mouseenter)="onParentEnter(item, $event.currentTarget)"
                      (mouseleave)="onParentLeave()">
                <span class="nav-icon" [innerHTML]="item.icon | icon"></span>
                <span class="nav-item-text">{{ item.key | translate }}</span>
                <span class="nav-chevron" [class.open]="isItemOpen(item.key)" [innerHTML]="'chevron' | icon"></span>
              </button>
              @if (isItemOpen(item.key)) {
                <div class="sub-nav">
                  @for (child of item.children; track child.route) {
                    <a class="nav-child"
                       [routerLink]="child.route"
                       routerLinkActive="active"
                       (click)="closeSidebar()">
                      <span class="nav-child-icon" [innerHTML]="child.icon | icon"></span>
                      {{ child.key | translate }}
                    </a>
                  }
                </div>
              }
            } @else {
              <a class="nav-item"
                 [routerLink]="item.route"
                 routerLinkActive="active"
                 (click)="closeSidebar()"
                 (mouseenter)="onNavEnter(item.key, $event.currentTarget)"
                 (mouseleave)="onNavLeave()">
                <span class="nav-icon" [innerHTML]="item.icon | icon"></span>
                <span>{{ item.key | translate }}</span>
              </a>
            }
          }
        </div>
      }
    </div>

  </aside>

  <!-- ── Collapsed tooltip ────────────────────────────────── -->
  @if (collapsed() && tooltipKey()) {
    <div class="nav-tooltip" [style.top.px]="tooltipTop()">
      {{ tooltipKey()! | translate }}
    </div>
  }

  <!-- ── Collapsed flyout ─────────────────────────────────── -->
  @if (collapsed() && flyoutItem()) {
    <div class="collapsed-flyout"
         [style.top.px]="flyoutTop()"
         (mouseenter)="onFlyoutEnter()"
         (mouseleave)="onFlyoutLeave()">
      <div class="cf-label">{{ flyoutItem()!.key | translate }}</div>
      @for (child of flyoutItem()!.children!; track child.route) {
        <a class="cf-child nav-child"
           [routerLink]="child.route"
           routerLinkActive="active"
           (click)="onFlyoutLeave(); closeSidebar()">
          {{ child.key | translate }}
        </a>
      }
    </div>
  }

  <!-- ── Overlay (mobile) ─────────────────────────────────── -->
  @if (sidebarOpen()) {
    <div class="sidebar-overlay" (click)="closeSidebar()"></div>
  }

  <!-- ── Main area ────────────────────────────────────────── -->
  <div class="main">

    <header class="topbar">
      <button class="icon-btn menu-btn" type="button" (click)="toggleSidebar()">
        <span [innerHTML]="'menu' | icon"></span>
      </button>

      <button class="icon-btn collapse-btn" type="button" (click)="toggleCollapse()">
        <span [innerHTML]="'panel' | icon"></span>
      </button>

      <div class="spacer"></div>

      <div class="clock-chip">
        <span [innerHTML]="'clock' | icon"></span>
        <span class="clock-date">{{ riyadhDate() }}</span>
        <span class="clock-time">{{ riyadhTime() }}</span>
        <b class="clock-city">Riyadh</b>
      </div>

      <div class="search" [class.open]="searchOpen()"
           (mousedown)="!searchOpen() && $event.preventDefault()"
           (click)="openSearch(); searchInput.focus()">
        <span class="search-icon-btn">
          <span [innerHTML]="'search' | icon"></span>
        </span>
        <input #searchInput
               [placeholder]="'search' | translate"
               type="search"
               [value]="searchQuery()"
               (input)="onSearchInput($any($event.target).value)"
               (focus)="openSearch()"
               (blur)="closeSearch(searchInput)">

        @if (searchOpen() && searchQuery().trim()) {
          <div class="search-results">
            @if (searchResults().length) {
              @for (page of searchResults(); track page.route) {
                <button type="button" class="search-result-item" (click)="goToPage(page)">
                  <span class="search-result-icon" [innerHTML]="page.icon | icon"></span>
                  <span>{{ page.key | translate }}</span>
                </button>
              }
            } @else {
              <div class="search-no-results">{{ 'search.noresults' | translate }}</div>
            }
          </div>
        }
      </div>

      <div class="lang-toggle">
        <button [class.active]="i18nService.lang() === 'en'" (click)="setLang('en')">EN</button>
        <button [class.active]="i18nService.lang() === 'ar'" (click)="setLang('ar')">AR</button>
      </div>

      <button class="icon-btn" type="button" (click)="toggleTheme()">
        <span [innerHTML]="(themeService.isDark() ? 'sun' : 'moon') | icon"></span>
      </button>

      <div class="user-menu-wrap">
        <button type="button" class="user-chip user-chip-btn" (click)="toggleUserMenu()">
          <div class="avatar">{{ adminInitials }}</div>
          <div class="user-meta">
            <b>{{ admin?.fullName || 'Admin' }}</b>
          </div>
          <span class="user-chevron" [class.open]="userMenuOpen()" [innerHTML]="'chevron' | icon"></span>
        </button>

        @if (userMenuOpen()) {
          <div class="user-menu-overlay" (click)="closeUserMenu()"></div>
          <div class="user-menu">
            <div class="user-menu-head">
              <div class="avatar">{{ adminInitials }}</div>
              <div>
                <b>{{ admin?.fullName || 'Admin' }}</b>
                <small>{{ admin?.email }}</small>
              </div>
            </div>
            <div class="user-menu-divider"></div>
            <button type="button" class="user-menu-item" (click)="openChangePassword()">
              <span [innerHTML]="'shield' | icon"></span>
              <span>Change Password</span>
            </button>
            <button type="button" class="user-menu-item user-menu-item-danger" (click)="closeUserMenu(); logout()">
              <span [innerHTML]="'logout' | icon"></span>
              <span>Logout</span>
            </button>
          </div>
        }
      </div>
    </header>

    <main class="content">
      @if (layoutService.pageTitle()) {
        <div class="page-heading">
          <h1>{{ layoutService.pageTitle() | translate }}</h1>
          @if (layoutService.pageSub()) {
            <div class="page-sub">{{ layoutService.pageSub() | translate }}</div>
          }
        </div>
      }
      <router-outlet></router-outlet>
    </main>

  </div>
</div>

<!-- ── Change password modal ────────────────────────────── -->
@if (changePasswordOpen()) {
  <div class="modal-overlay" (click)="closeChangePassword()">
    <div class="modal" style="max-width:420px" (click)="$event.stopPropagation()">
      <h3>Change Password</h3>
      <p>Update the password for your admin account.</p>

      <div class="field">
        <label>Current password</label>
        <input class="input" type="password" [(ngModel)]="currentPassword" autocomplete="current-password">
      </div>
      <div class="field">
        <label>New password</label>
        <input class="input" type="password" [(ngModel)]="newPassword" autocomplete="new-password">
      </div>
      <div class="field">
        <label>Confirm new password</label>
        <input class="input" type="password" [(ngModel)]="confirmPassword" autocomplete="new-password">
      </div>

      <div class="modal-actions" style="margin-top:6px">
        <button class="btn" type="button" (click)="closeChangePassword()">Cancel</button>
        <button class="btn btn-primary" type="button" disabled title="Not wired up yet — no backend endpoint">
          Save
        </button>
      </div>
    </div>
  </div>
}

<app-confirm-dialog></app-confirm-dialog>
<app-toast></app-toast>
